"use client";
import React, { useEffect, useState } from "react";

type PortfolioItem = {
  id: number;
  title: string;
  category: string;
  image: string;
  video: string; // Treat this as the URL to the project website
  type: string;
};

const Portfolio = () => {
  // Mock data
  const portfolioItems: PortfolioItem[] = [
    {
      id: 1,
      title: "Ai Champ",
      category: "Single Page websites",
      image: "/1.png",
      video: "https://aichamp.com/",
      type: "Single Page websites",
    },
    {
      id: 2,
      title: "Entrance Practice",
      category: "Products",
      image: "/2.png",
      video: "https://entrancepractice.com/",
      type: "Products",
    },
    {
      id: 3,
      title: "Dey's Publishing Website",
      category: "E-Commerce Websites",
      image: "/3.png",
      video: "https://deyspublishing.com/",
      type: "E-Commerce Websites",
    },
    {
      id: 4,
      title: "Newtown Sarbojanin",
      category: "Single Page websites",
      image: "/4.png",
      video: "https://newtownsarbojanin.com/",
      type: "Single Page websites",
    },
    {
      id: 5,
      title: "Base Build",
      category: "Products",
      image: "/5.png",
      video: "https://basebuildmath.com/",
      type: "Products",
    },
    {
      id: 6,
      title: "Dey's Publishing Mobile App",
      category: "Mobile Applications",
      image: "/6.png",
      video:
        "https://play.google.com/store/apps/details?id=com.arindam.pal.deysdeveloper&hl=en",
      type: "Mobile Applications",
    },
  ];

  const categories: string[] = [
    "All",
    "Products",
    "Single Page websites",
    "E-Commerce Websites",
    "Mobile Applications",
  ];

  const [selectedCategory, setSelectedCategory] = useState<string>("All");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [tempImages, setTempImages] = useState<PortfolioItem[]>([]);

  const itemsPerPage = 6;

  // Filter portfolioItems by selectedCategory
  const filteredItems =
    selectedCategory === "All"
      ? portfolioItems
      : portfolioItems.filter((item) => item.type === selectedCategory);

  useEffect(() => {
    // Reset the page and set the first batch of images when category changes
    setCurrentPage(1);
    setTempImages(filteredItems.slice(0, itemsPerPage));
  }, [selectedCategory]); // Remove filteredItems from dependency array

  const handleThumbnailClick = (url: string) => {
    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  const handleLoadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    setTempImages(filteredItems.slice(0, (currentPage + 1) * itemsPerPage));
  };

  return (
    <div className="text-[#111010] pb-12 px-4 md:px-12 w-full lg:px-16">
      <>
        {/* Categories */}
        <div className="w-full mb-8 md:mb-12">
          <div className="flex w-full overflow-x-auto space-x-2 md:space-x-8 animate-fadeIn ">
            <div className="flex flex-nowrap justify-center space-x-6 md:space-x-10 mx-auto">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`relative group whitespace-nowrap py-1 `}
                >
                  {category}
                  <span
                    className={`absolute left-0 bottom-0 w-0 h-[1.4px] bg-gray-900 transition-all duration-300 ease-in-out ${
                      selectedCategory === category
                        ? " w-full"
                        : "group-hover:w-full"
                    }`}
                    aria-hidden="true"
                  ></span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Portfolio Items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-10 animate-fadeIn transition-all duration-300">
          {tempImages.map((item) => (
            <div
              key={item.id}
              className="relative shadow-lg group overflow-hidden rounded-lg animate-popIn transition-all duration-300 hover:cursor-pointer hover:shadow-2xl"
              onClick={() => handleThumbnailClick(item.video)}
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            >
              <div className="h-full w-full inner-div">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[30vh] sm:h-[28vh] md:h-[32vh] object-cover transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="text-center px-4">
                  <h2 className="text-lg font-semibold text-white">
                    {item.title}
                  </h2>
                  <p className="text-sm text-gray-300">{item.category}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {tempImages.length < filteredItems.length && (
          <div className="flex justify-center mt-8 animate-fadeIn">
            <button
              onClick={handleLoadMore}
              className="relative group text-black font-bold py-2 px-4 bg-white rounded shadow-md hover:shadow-lg"
            >
              Load More
              <span
                className="absolute left-0 bottom-0 w-0 h-[1.4px] bg-gray-300 transition-all duration-300 ease-in-out group-hover:w-full"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        )}
      </>
    </div>
  );
};

export default Portfolio;
